<template>
  <div class="body">
    <h1 class="title is-size-2 has-text-primary">Contact Us</h1>
    <h1 class="subtitle">Thank you for your interest in SEQu-SUITE. Feel free to send us a message with the form below.</h1>
    <div class="columns is-desktop is-variable is-8">
      <div class="column is-two-thirds-desktop">
        <!-- todo: activate when live -->
        <form action=" https://formsubmit.co/jpatdu@smpcopartners.com" method="POST">
          <b-field label="Name">
            <b-input type="text" name="name" required></b-input>
          </b-field>
          <b-field label="Email Address">
            <b-input type="email" name="email" required></b-input>
          </b-field>
          <b-field label="Phone Number">
            <b-input type="tel" name="phone" required></b-input>
          </b-field>
          <b-field label="Message">
            <b-input type="textarea" name="message" required></b-input>
          </b-field>
          <input type="hidden" name="_replyto">
          <input type="hidden" name="_cc" value="dmanalastas@smpcopartners.com">
          <input type="text" name="_honey" style="display:none">
          <b-button tag="button" type="is-primary" native-type="submit">Send</b-button>
        </form>
      </div>
      <div class="column">
        <h1 class="subtitle">Saulong Manalastas Patdu and Co Partners, Inc.</h1>
        <p>3F Chamber of Commerce of the Philippine Islands Bldg., 3 Magallanes Drive, Intramuros, City of Manila, Philippines 1002</p>
        <br>
        <p>Email: admin@smpcopartners.com</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Contact"
  }
</script>

<style scoped>
  .body {
    padding: 8%;
  }
</style>